<div class="ai-progress">
    <!-- Event log -->
    <div class="ai-progress__log" #logContainer *ngIf="progressEvents.length > 0">
        <div
            class="ai-progress__entry"
            *ngFor="let evt of progressEvents; trackBy: trackByIndex; let i = index; let last = last"
            [class.ai-progress__entry--latest]="last">
            <span class="ai-progress__idx">{{ i + 1 }}.</span>
            <span class="ai-progress__text">
                <ng-container *ngIf="evt.messageKey; else legacyText">
                    {{ evt.messageKey | i18next: (evt.messageParams || {}) }}
                </ng-container>
                <ng-template #legacyText>{{ formatEvent(evt) }}</ng-template>
            </span>
        </div>
    </div>
</div>
